import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import * as moment from "moment";
import JobRunActivity from "./jobRunActivity";
import * as _ from "lodash";

export default class HourActivity {
  id: string;
  isHour: boolean;
  hour: string;
  period: string;
  jobRun: JobRunActivity;
  startTime: Date;
  endTime: Date;
  isLocked: boolean;
  hasFailedChecks: boolean;
  hasPassedChecks: boolean;
  hasNoChecks: boolean;
  overridden: boolean;
  private checkLists: apsViewModels.CheckListActivity[];

  constructor(startTime: Date, endTime: Date, isLocked: boolean, timeZoneId: string) {
    this.startTime = startTime;
    this.endTime = endTime;
    this.isLocked = isLocked;
    var momentStartTime = moment.tz(this.startTime, timeZoneId);
    this.id = momentStartTime.format();
    this.isHour = true;
    this.hour = momentStartTime.format('h');
    this.period = momentStartTime.format('a');
    this.checkLists = [];
    this.hasFailedChecks = false;
    this.hasPassedChecks = false;
    this.hasNoChecks = true;
    this.overridden = false;
  }

  withinHour(time: Date): boolean {
    return this.startTime.getTime() <= time.getTime()
      && time.getTime() < this.endTime.getTime();
  }

  private updateCheckListStatus(checkList: apsViewModels.CheckListActivity): void {
    this.hasNoChecks = false;
    if (checkList.hasFailures || _.some(this.checkLists, (cl: apsViewModels.CheckListActivity) => cl.hasFailures)) {
      this.hasFailedChecks = true;
      this.hasPassedChecks = false;
      return;
    }

    this.hasFailedChecks = false;
    this.hasPassedChecks = true;
  }

  addOrUpdateCheckList(checkList: apsViewModels.CheckListActivity): void {
    var index = _.findIndex(this.checkLists, {id: checkList.id});
    if (index < 0) {
      this.checkLists.push(checkList);
    } else {
      this.checkLists[index] = checkList;
    }
    this.updateCheckListStatus(checkList);
  }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/models/activity/hourActivity.ts